import React, {PureComponent} from "react";
import {UrlBuilder} from "../../../core/url/UrlBuilder";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import Fade from "@mui/material/Fade";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import EditIcon from "@mui/icons-material/Edit";
import ListItemText from "@mui/material/ListItemText";
import TableContainer from "@mui/material/TableContainer";
import DeleteIcon from '@mui/icons-material/Delete';
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import {DatePicker, LocalizationProvider} from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';
import TextField from "@mui/material/TextField";
import moment from "moment";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";

class MeasurementLogsTable extends PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			measurement: this.props.measurement,
			logInEditableMode: null,
			dropDownMenuAnchorEl: null,
			isLoading: false,
			isSubmissionLoading: false,
			value: this.props.measurement && this.props.measurement.logs[0] ? this.props.measurement.logs[0].value : 0,
			dateCreated: new Date(),
			editedLogValue: null,
		};
	}

	componentWillReceiveProps(nextProps, nextContext) {
		this.setState({
			measurement: nextProps.measurement,
			isLoading: nextProps.isLoading
		});
	}

	submitNewLog = async (event) => {
		event.preventDefault();

		this.setState({
			isSubmissionLoading: true,
		});

		let measurementLogToSave = {
			MeasurementId: this.state.measurement.id,
			Value: this.state.value,
			DateCreated: moment(this.state.dateCreated).format('L, h:mm:ss A'),
		};

		await fetch(UrlBuilder.measurements.measurementLogsApi(), {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(measurementLogToSave)
		}).then(() => this.props.refreshParentFunc('New log created.'));

		this.setState({
			isSubmissionLoading: false,
			dateCreated: new Date(),
		});
	}

	submitLogEdit = async (event) => {
		event.preventDefault();

		this.setState({
			isSubmissionLoading: true,
		});

		let measurementLogToUpdate = {
			Id: this.state.logInEditableMode.id,
			Value: this.state.editedLogValue,
		};

		await fetch(UrlBuilder.measurements.measurementLogsApi(), {
			method: 'PUT',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(measurementLogToUpdate)
		}).then(() => this.props.refreshParentFunc('Log updated.'));

		this.setState({
			isSubmissionLoading: false,
			editedLogValue: null,
			logInEditableMode: null,
		});
	}

	deleteMeasurementLog = async (event, log) => {
		event.preventDefault();
		event.stopPropagation();

		await fetch(UrlBuilder.measurements.measurementLogsApi(log.id), {
			method: 'DELETE',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
		})
			.then(() => this.props.refreshParentFunc("Log successfully deleted."));
	}

	openDropdownMenu = (event) => {
		event.preventDefault();
		event.stopPropagation();

		this.setState({
			dropDownMenuAnchorEl: event.currentTarget
		});
	};

	closeDropdownMenu = (e) => {
		e.preventDefault();
		e.stopPropagation();

		this.setState({
			dropDownMenuAnchorEl: null
		});
	};

	toggleEditableLog(e, log) {
		e.preventDefault();
		e.stopPropagation();

		this.setState({
			logInEditableMode: log,
			editedLogValue: log.value,
			dropDownMenuAnchorEl: null
		});
	}

	isToday = (someDateString) => {
		const someDate = new Date(someDateString);
		const today = new Date();
		return (someDate.toDateString() === today.toDateString());
	}

	setSelectedLog = (log) => {
		this.setState({
			value: log.value,
			dateCreated: log.dateCreated,
		});
	}

	handleDateChange = (date) => {
		this.setState({
			dateCreated: date
		});
	};

	updateStateInputValues = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		});
	}

	submitWithEnter = (e) => {
		if (e.key === 'Enter') {
			this.submitNewLog(e);
		}
	}

	submitEditWithEnter = (e) => {
		if (e.key === 'Enter') {
			this.submitLogEdit(e);
		}
	}

	render() {
		return (
			<Box sx={{ width: '100%', p: 0 }}>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pt: 1, pb: 1, px: 0.5 }}>
					<Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
						Log History
					</Typography>
					{this.state.isLoading && <CircularProgress size={14} color="inherit" />}
				</Box>

				<Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
					<TableContainer>
						<Table size="small">
							<TableHead>
								<TableRow>
									<TableCell sx={{ fontWeight: 600, fontSize: 12, color: 'text.secondary' }}>Date</TableCell>
									<TableCell align="left" sx={{ fontWeight: 600, fontSize: 12, color: 'text.secondary' }}>Value</TableCell>
									<TableCell align="left" width={48} />
								</TableRow>
							</TableHead>

							<TableBody>
								<TableRow sx={{ bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(245,0,87,0.06)' : 'rgba(245,0,87,0.03)' }}>
									<TableCell component="th" scope="row" align="left">
										<LocalizationProvider dateAdapter={AdapterDateFns}>
											<DatePicker
												inputFormat="dd/MM/yyyy"
												id="dateCreated"
												name="dateCreated"
												disableFuture
												value={this.state.dateCreated}
												onChange={this.handleDateChange}
												renderInput={(params) => <TextField {...params} size='small' sx={{ maxWidth: 150 }} />}
											/>
										</LocalizationProvider>
									</TableCell>

									<TableCell align="left" padding='none'>
										<TextField
											variant='outlined'
											margin="dense"
											type='number'
											inputMode='decimal'
											required
											id='value'
											name={'value'}
											value={this.state.value}
											onChange={this.updateStateInputValues}
											onKeyPress={this.submitWithEnter}
											InputLabelProps={{ shrink: true }}
											sx={{ maxWidth: 80, mt: 0, mb: 0 }}
											size='small'
										/>
									</TableCell>

									<TableCell align="right">
										<IconButton
											size="small"
											onClick={this.submitNewLog}
											disabled={this.state.isSubmissionLoading}
											color="secondary"
										>
											<AddIcon fontSize="small" />
										</IconButton>
									</TableCell>
								</TableRow>

								{this.state.measurement?.logs.map((log) =>
									<TableRow key={"logs_" + log.id} hover onClick={() => this.setSelectedLog(log)} sx={{ cursor: 'pointer' }}>
										<TableCell component="th" scope="row" align="left">
											<Typography variant='caption' sx={this.isToday(log.dateCreated) ? { fontWeight: 700 } : {}}>
												{(new Date(log.dateCreated)).toDateString()}
											</Typography>
										</TableCell>

										<TableCell align="left" padding='none'>
											{this.state.logInEditableMode && log.id === this.state.logInEditableMode.id ?
												<TextField
													variant='outlined'
													margin="dense"
													type='number'
													inputMode='decimal'
													required
													id='editedLogValue'
													name='editedLogValue'
													value={this.state.editedLogValue}
													onClick={(e) => e.stopPropagation()}
													onChange={this.updateStateInputValues}
													autoFocus
													onKeyPress={this.submitEditWithEnter}
													InputLabelProps={{ shrink: true }}
													sx={{ maxWidth: 80, mt: 0, mb: 0 }}
													size='small'
												/>
												:
												<Typography variant="body2">
													{log.value}
												</Typography>
											}
										</TableCell>

										<TableCell align="right">
											{this.state.logInEditableMode && log.id === this.state.logInEditableMode.id ?
												<IconButton size="small" onClick={this.submitLogEdit} disabled={this.state.isSubmissionLoading}>
													<SaveIcon fontSize="small" />
												</IconButton>
												:
												<>
													<IconButton id={log.id} onClick={this.openDropdownMenu} size="small">
														<MoreVertIcon fontSize="small" />
													</IconButton>
													<Menu
														anchorEl={this.state.dropDownMenuAnchorEl}
														open={Boolean(this.state.dropDownMenuAnchorEl && this.state.dropDownMenuAnchorEl.id == log.id)}
														onClose={this.closeDropdownMenu}
														TransitionComponent={Fade}
													>
														<MenuItem onClick={(e) => this.toggleEditableLog(e, log)}>
															<ListItemIcon>
																<EditIcon fontSize="small"/>
															</ListItemIcon>
															<ListItemText primary="Edit"/>
														</MenuItem>
														<MenuItem onClick={e => this.deleteMeasurementLog(e, log)}>
															<ListItemIcon>
																<DeleteIcon fontSize="small"/>
															</ListItemIcon>
															<ListItemText primary="Delete"/>
														</MenuItem>
													</Menu>
												</>
											}
										</TableCell>
									</TableRow>
								)}
							</TableBody>
						</Table>
					</TableContainer>
				</Paper>
			</Box>
		);
	}
}

export default MeasurementLogsTable;
